import { useInvalidateRpcQueryFn } from '@/api/rpc/client';

/** Reload an invoice and its activity after a workflow run settles. */
export function useRefreshAPInvoice() {
  return useInvalidateRpcQueryFn((orpc, { id }: { id: string }) => [
    orpc.accountsPayable.invoices.get.queryKey({ input: { id } }),
    orpc.accountsPayable.invoices.listChangeLog.queryKey({
      input: { apInvoiceId: id },
    }),
  ]);
}
